// Toogle Password
export const tooglePassword = function (passwordInput, passwordIcon) {
	passwordIcon.addEventListener("click", function () {
	  	// toggle the type attribute
	  	const type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
	 	passwordInput.setAttribute("type", type);
  
	  	// toggle the icon
	  	this.classList.toggle("bi-eye");
	});
};
